// extracted by mini-css-extract-plugin
export default {"LoginTextContainer":"LoginText_LoginTextContainer__Au1gZ","LoginText":"LoginText_LoginText__FBt00","CopyrightText":"LoginText_CopyrightText__o2hsN"};